import React from 'react';
import { FooterProvider } from 'Context/FooterContext';
import Content from './Content';

const Unauthenticated = (props) => {
  return (
    <FooterProvider>
      <Content {...props} />
    </FooterProvider>
  );
};

export default Unauthenticated;
